module.exports = __webpack_public_path__ + "static/media/panaderia.77197cec.svg";